import { FirstNamedInsured } from "pmt-types/src/models/FirstNamedInsured.ts";
import { useMutationSearchEntities } from "./useMutationSearchEntities.ts";

export const useMutationSearchFirstNamedInsureds = () =>
  useMutationSearchEntities<FirstNamedInsured>("firstNamedInsureds");
